import {post} from "@/utils/request";

export default class apiConfig{
  static async commonConfig(){
    return post('/home/config/commonConfig')
  }
}
